<template>
    <div class="mainpage">
        <div ref="leftpage" class="leftpage" v-show="isLeftPageVisible">
            <ul class = "ulstyle">
                <li
                    v-for="(item, index) in jsonObject"
                    :key="`${item.label}-${index}`"
                    :class="[{ selected: isSelected(item) }, { 'submenu-entry': item.level > 0 }]"
                    @click="navigateToDocument(item)"
                >
                    {{ item.label }}
                </li>
            </ul>
        </div>


        <div class="rightpage">
            <div class = "showindex">
                <button id="showleftpage" @click="toggleLeftPage">
                    <img src="../image/index.png" alt="Toggle Left Page" width="25" height="25" />
                </button>
                <router-view v-slot="{ Component, route }">
                    <transition name="kendou-route" mode="out-in">
                        <component :is="Component" :key="route.fullPath"></component>
                    </transition>
                </router-view>
            </div>
            
        </div>
    </div>
</template>

<script setup>
import { computed, onBeforeUnmount, onMounted, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { getKendouNavItems } from '../shared/siteNavigation';
import { useSiteLanguage } from '../store/siteLanguage';

const router = useRouter();
const route = useRoute();
const { lang } = useSiteLanguage();
const isLeftPageVisible = ref(window.innerWidth >= 768);
const jsonObject = computed(() => getKendouNavItems(lang.value));

function toggleLeftPage() {
    isLeftPageVisible.value = !isLeftPageVisible.value;
}

function handleResize() {
    isLeftPageVisible.value = window.innerWidth >= 768;
}

function navigateToDocument(item) {
    router.push(item.path);
}

function isSelected(item) {
    return route.fullPath === item.path;
}

onMounted(() => {
    window.addEventListener("resize", handleResize);
});

onBeforeUnmount(() => {
    window.removeEventListener("resize", handleResize);
});
</script>

<style lang="scss">
    @import './Maincss.scss';

    .ulstyle li.submenu-entry {
        padding-left: 22px;
        font-size: 13px;
        color: #5b4638;
        background: #f3eee7;
    }

    .ulstyle li.submenu-entry:hover {
        background: #eadfce;
    }

    :deep(.kendou-route-enter-active),
    :deep(.kendou-route-leave-active) {
        transition: opacity 0.42s ease, transform 0.42s ease, filter 0.42s ease;
    }

    :deep(.kendou-route-enter-from) {
        opacity: 0;
        transform: translateY(22px) scale(0.985);
        filter: blur(8px);
    }

    :deep(.kendou-route-leave-to) {
        opacity: 0;
        transform: translateY(-14px) scale(0.992);
        filter: blur(6px);
    }

    :deep(.kendou-route-enter-to),
    :deep(.kendou-route-leave-from) {
        opacity: 1;
        transform: translateY(0) scale(1);
        filter: blur(0);
    }
</style>
